
import type { BlogPost } from './types/BlogTypes';
import {
  generalPosts,
  treatmentsPosts,
  preventiveCarePosts,
  medicalResearchPosts,
  gumHealthPosts
} from './blog';

// Combine all blog posts from different categories
export const blogPosts: BlogPost[] = [
  ...generalPosts,
  ...treatmentsPosts,
  ...preventiveCarePosts,
  ...medicalResearchPosts,
  ...gumHealthPosts
];

// Function to get related posts based on current post ID
export const getRelatedPosts = (currentPostId: number, limit: number = 3): BlogPost[] => {
  // Get the current post
  const currentPost = blogPosts.find(post => post.id === currentPostId);
  
  if (!currentPost) return [];
  
  // Find posts in the same category
  const sameCategory = blogPosts.filter(
    post => post.id !== currentPostId && post.category === currentPost.category
  );
  
  // If we don't have enough posts in the same category, get some from other categories
  if (sameCategory.length < limit) {
    const otherPosts = blogPosts.filter(
      post => post.id !== currentPostId && post.category !== currentPost.category
    );
    
    // Combine and limit
    return [...sameCategory, ...otherPosts].slice(0, limit);
  }
  
  // Shuffle the same category posts and return the required number
  return sameCategory.sort(() => Math.random() - 0.5).slice(0, limit);
};

// Function to search blog posts based on a query
export const searchBlogPosts = (query: string): BlogPost[] => {
  const lowercaseQuery = query.toLowerCase();
  
  return blogPosts.filter(post => {
    return (
      post.title.toLowerCase().includes(lowercaseQuery) ||
      post.excerpt.toLowerCase().includes(lowercaseQuery) ||
      post.content.toLowerCase().includes(lowercaseQuery) ||
      post.category.toLowerCase().includes(lowercaseQuery)
    );
  });
};

// Function to get all unique blog categories
export const getBlogCategories = (): string[] => {
  const categories = blogPosts.map(post => post.category);
  return [...new Set(categories)];
};

// Export types for usage elsewhere
export * from './types/BlogTypes';
export * from './blog';
